module.exports = __webpack_public_path__ + "img/TS6101-305.3ac06942.jpg";